import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  students: [],
  checkedStudent: null,
  tmp: null,
};

const getters = {
  getStudents: (state) => state.students,
  getStudentById: (state) => (id) => state.students.find((x) => x.id == id),
  getCheckedStudent: (state) => state.checkedStudent,
};

const actions = {
  async uploadStudentsFile({ commit }, file) {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const resp = await api.post("/students/import", formData);

      if (resp.status == 200) {
        commit("dooTemp", 1);
        return true;
      }
    } catch (error) {
      return false;
    }
  },
  async checkStudent({ commit }, stu_num) {
    try {
      const resp = await api.get(`/students_check/${stu_num}`);
      if (resp.status == 200) {
        const student = resp.data.data.student;
        //.log("students", student);
        commit("setCheckedStudent", student);
        return 200;
      } else {
        commit("setCheckedStudent", null);
      }
    } catch (error) {
      //   console.log("error", error.status);
      //   console.log("error", error);
      commit("setCheckedStudent", null);
      return error.status;
    }
  },
  async fetchStudents({ commit }) {
    try {
      const resp = await api.get("/students");
      if (resp.status == 200) {
        const students = resp.data.data.students;
        console.log("students", students);
        commit("setStudents", students);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateStudent({ commit }, student) {
    console.log("student:", student);
    try {
      const id = student.id;
      student._method = "patch";

      const resp = await api.post(`/students/${id}`, student);
      if (resp.status == 200) {
        const student = resp.data.data;
        commit("updateStudent", student);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addStudent({ commit }, student) {
    try {
      const resp = await api.post(`/students`, student);

      if (resp.status == 201) {
        const student = resp.data.data;

        commit("addStudent", student);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteStudent({ commit }, id) {
    try {
      const resp = await api.delete(`/students/${id}`);

      if (resp.status == 204) {
        commit("deleteStudent", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  dooTemp(state, x) {
    state.tmp = x;
  },
  setCheckedStudent(state, student) {
    state.checkedStudent = student;
  },
  setStudents(state, students) {
    state.students = students;
  },
  updateStudent(state, student) {
    const id = student.id;
    const index = state.students.findIndex((student) => student.id == id);
    if (index !== -1) {
      state.students[index] = student;
    }
  },
  addStudent(state, student) {
    state.students.unshift(student);
  },

  deleteStudent(state, id) {
    const index = state.students.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.students.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
